
import React, {Component} from 'react'
import { Button, Input, Form , Menu, Dropdown, Modal, Image, Header, Icon} from 'semantic-ui-react'
import styled from 'styled-components';

const MessageUnit = styled.div`
  display: flex;
  justify-content:center;
  // position: relative;
  // top:-20px;


`


export const options = [
  { key: 1, text: 'Неисправность', value: 1 },
  { key: 2, text: 'Заявка', value: 2 },
  { key: 3, text: 'Вопрос', value: 3 },
]


class Formmessage extends Component {
  constructor(props){
    super(props)
    this.handleChange=this.handleChange.bind(this)
    this.sendMessage=this.sendMessage.bind(this)
    this.state={
      messagetype:'',
      messagetypeText:'',
      messageformDraw:false,
      errForm:false,
      Username:'',
      Contact:'',
      Phone:'',
      Message:'',
      answerpost:false,
      answerposterror:'',
      fetching:false
    }
  }


  handleChange = (e, {  value, text }) =>
    this.setState({ messagetype:value, messagetypeText:text }, ()=>console.log('value'+this.state.messagetype))

sendMessage(){
 const { Username, Contact, Message, messagetypeText} = this.state
 this.setState({fetching:true})


  if(!Username || !Contact ||  !Message){
      this.setState({errForm:true})
  }
  else{


          fetch('http://ocnit.tula.ru/api/req.php',

              {
            method: 'POST',
            headers: new Headers({
                     'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type

            }),

            body: "action=messagerequest&name="+Username+"&contact="+Contact+"&message="+Message+"&messagetype="+messagetypeText

              }    )
              .then((response)=>response.text())

                .then((answerpost)=>{

                      if(answerpost == 'Ok'){
                            this.setState({answerpost:true})
                      }
                      else {
                            this.setState({answerposterror:answerpost})
                      }
                      this.setState({fetching:false})
                })

      this.setState({errForm:false})
  }





}

render(){
  // const {test, errname} = this.props
  const {messagetypeText, answerpost, answerposterror, fetching, errForm, messageformDraw, Username, Contact, Message } = this.state
  return(
    <MessageUnit>





            <Modal open={messageformDraw}  closeIcon onClose={()=>this.setState({messageformDraw:false})}  className='height70' >

                <Modal.Content scrolling closeIcon className='height70' >
                  <div className='header'>Сообщение в службу техподдержки</div>
                  <Modal.Actions>
                  <div style={{'text-align':'center'}}>
                  {fetching ?
                        'Загружаем'
                  :

                        null

                   }

                   { (answerpost || answerposterror || fetching ) && !errForm ?
                     null
                     :
                     <Form>{this.state.messagetypeText}
                       <div style={{'padding':'12px'}}>
                           Сообщение: <Dropdown text={messagetypeText} options={options} simple item onChange={this.handleChange} />
                       </div>

                       <Form.Input
                         onChange={(e)=>this.setState({Username:e.target.value})}
                                error={ !Username && errForm ? true:false}
                         label='Ваше имя'
                         placeholder='Ваше имя'
                       />

                       <Form.Input
                         error={ !Contact && errForm ? true:false}
                         fluid
                         label='Ваш контакт для обратной связи:'
                         onChange={(e)=>this.setState({Contact:e.target.value, errContact:null})}
                       />
                     <div style={{'display':'none'}}>
                       <Form.Input

                         fluid
                         label='Телефон:'
                         onChange={(e)=>this.setState({Phone:e.target.value})}
                       />
                   </div>

                     <Form.TextArea
                         error={ !Message && errForm ? true:false}
                         fluid
                         label='Суть вопроса:'
                         onChange={(e)=>this.setState({Message:e.target.value, errMessage:null})}
                       />
                       {errForm ?
                         <div style={{'color':'red'}}>
                           Все поля формы обязательны для заполнения.
                         </div>
                         :
                         null
                       }

                     <a className='pointer' href={null} onClick={()=>this.setState({messageformDraw:false})}>закрыть</a> &nbsp;&nbsp;&nbsp;
                     <Button onClick={this.sendMessage} inverted color='blue'>
                         Отправить
                       </Button>

                     </Form>

                   }

                  {answerpost && !answerposterror && !errForm ?
                    <div style={{'color':'green'}}>
                        Сообщение принято.
                    </div>
                    :
                    null
                  }
                  {answerposterror ?
                    <div style={{'color':'red'}}>
                        ОШИБКА! Сообщение не принято.
                    </div>
                    :
                    null
                  }


                  </div>
                </Modal.Actions>
                </Modal.Content>
              </Modal>


          <div onClick={()=>this.setState({messageformDraw:true})}><a  style={{ 'position':'relative','top':'-12px','cursor':'pointer', 'font-size':'1.2em', 'font-weight':'bold', fontStyle: 'italic'}} href={null}>
            (Отправить сообщение)
          </a></div>


    </MessageUnit>

  )
  }

}

export default Formmessage
